import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ArraysHelper {
  static mergeArraysByObjId(oldItems: any[], newItems: any[]) {
    return [...new Set([...oldItems, ...newItems])]
      .filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id === value.id
        )));
  }
}
